/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"

import Header from "./Header/header"
import "materialize-css/dist/css/materialize.min.css"
import "./MainCss/fontawesome-5.15.3/css/all.css"
import "./MainCss/layout.css"
import Footer from "./Footer"
import isBrowser from "./isBrowser"


const Layout = ({ children }) => {

  React.useEffect(() => {
    if(isBrowser()){
      document.addEventListener('keydown', function (e) {
        if(e.code === "F12") {
          e.preventDefault();
          return false;
        }
        if((e.ctrlKey && e.shiftKey && e.code === 'KeyI') || ( e.ctrlKey && e.code === 'KeyU')
          || (e.ctrlKey && e.shiftKey && e.code === 'KeyJ') || (e.ctrlKey && e.shiftKey && e.code === 'KeyC')) {
          e.preventDefault();
          return false;
        }
      }, false);
    }
  }, [children])


  return (
    <>
      <div onContextMenu={(e)=>{e.preventDefault()}} 
        onCopy={(e)=>{e.preventDefault()}} 
        onSelect={(e)=>{e.preventDefault()}}
        onDrag={(e)=>{e.preventDefault()}}
      >
        <Header />
        <div>
          <main>{children}</main>
        </div>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
